import { render } from "./AllPermission.vue?vue&type=template&id=36bc8e27"
import script from "./AllPermission.vue?vue&type=script&lang=js"
export * from "./AllPermission.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__